import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { detectLastClicked, WaitSynchronousScripts, setCurrentlyInTransaction, createVisual, probablyResetParentContainerForVisual, putScriptInlineToDom, findBlockedNodes, transformInlineStyleRules, transformToOriginalAttribute, HTML_ATTRIBUTE_BLOCKER_ID, HTML_ATTRIBUTE_COOKIE_IDS, HTML_ATTRIBUTE_BLOCKER_CONNECTED, HTML_ATTRIBUTE_INLINE, HTML_ATTRIBUTE_UNBLOCKED_TRANSACTION_COMPLETE, OPT_IN_CONTENT_BLOCKER_ALL, applyJQueryReadyInitiator, applyJQueryEventInitiator, applyNativeEventListenerInitiator, applyWindowOnloadInitiator, setLastClickedConnectedCounter, OPT_IN_CONTENT_BLOCKER } from "..";

/**
 * Refresh the DOM content depending on acceptance. It covers the following things:
 *
 * - Get all available blocked content
 * - Unblock blocked content depending on acceptance
 * - All other blocked content gets a visual content-blocker (if possible)
 */
function findAndUnblock(_x) {
  return _findAndUnblock.apply(this, arguments);
}

function _findAndUnblock() {
  _findAndUnblock = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var checker, visual, overwriteAttributeValue, transactionClosed, customInitiators, foundAnyLastClicked, nodes, unblockedNodes, unmount, _iterator, _step, row, consent, node, isVisualCb, blocker, connectedBlocker, isLastClicked, contentBlockers, _iterator2, _step2, _contentBlocker, _ownerDocument, _defaultView, waitSynchronousScripts, hasInlineAttribute, _yield$transformToOri, performedClick;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            checker = _ref.checker, visual = _ref.visual, overwriteAttributeValue = _ref.overwriteAttributeValue, transactionClosed = _ref.transactionClosed, customInitiators = _ref.customInitiators;
            setCurrentlyInTransaction(true);
            foundAnyLastClicked = false;
            nodes = findBlockedNodes(checker);
            transformInlineStyleRules(checker); // A collection of all unblocked content for this "transaction"; so we can keep track a batch
            // of unblocked items to keep dependencies intact (e.g. Custom script is blocked and needs Google Maps
            // API do be available).

            unblockedNodes = [];

            unmount = function unmount(element) {
              var _visual$unmount;

              visual === null || visual === void 0 ? void 0 : (_visual$unmount = visual.unmount) === null || _visual$unmount === void 0 ? void 0 : _visual$unmount.call(visual, element);
              probablyResetParentContainerForVisual(element, false);
              element.remove();
            }; // In some cases, through custom event triggers and unblocked scripts, HTML elements could be "recreated" in our DOM
            // without our changes to mark the DOM node as "complete". Lets find those nodes and mark them correctly.


            document.querySelectorAll("[".concat(HTML_ATTRIBUTE_BLOCKER_ID, "]:not(.rcb-content-blocker):not([").concat(HTML_ATTRIBUTE_COOKIE_IDS, "]):not([").concat(HTML_ATTRIBUTE_UNBLOCKED_TRANSACTION_COMPLETE, "])")).forEach(function (n) {
              return n.setAttribute(HTML_ATTRIBUTE_UNBLOCKED_TRANSACTION_COMPLETE, "1");
            });
            _iterator = _createForOfIteratorHelper(nodes);
            _context.prev = 9;

            _iterator.s();

          case 11:
            if ((_step = _iterator.n()).done) {
              _context.next = 57;
              break;
            }

            row = _step.value;
            consent = row.consent, node = row.node, isVisualCb = row.isVisualCb, blocker = row.blocker;

            if (!consent) {
              _context.next = 54;
              break;
            }

            if (node.hasAttribute(HTML_ATTRIBUTE_COOKIE_IDS)) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("continue", 55);

          case 19:
            if (!isVisualCb) {
              _context.next = 22;
              break;
            }

            unmount(node);
            return _context.abrupt("continue", 55);

          case 22:
            // Immediate deactivate nodes for future unblocks
            node.removeAttribute(HTML_ATTRIBUTE_COOKIE_IDS);
            connectedBlocker = node.getAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED);
            isLastClicked = detectLastClicked(node);

            if (isLastClicked) {
              foundAnyLastClicked = true;
            } // Remove visual content blocker if not yet removed through above method


            if (connectedBlocker) {
              contentBlockers = Array.prototype.slice.call(document.querySelectorAll(".rcb-content-blocker[consent-blocker-connected=\"".concat(connectedBlocker, "\"]")));
              _iterator2 = _createForOfIteratorHelper(contentBlockers);

              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  _contentBlocker = _step2.value;
                  unmount(_contentBlocker);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            } // Overwrite global listeners so they get immediate executed


            _ownerDocument = node.ownerDocument;
            _defaultView = _ownerDocument.defaultView;
            applyJQueryReadyInitiator(_ownerDocument);
            applyJQueryEventInitiator(_ownerDocument, _defaultView, "load"); // $(window).load()

            applyNativeEventListenerInitiator(_defaultView, "load");
            applyNativeEventListenerInitiator(_ownerDocument, "DOMContentLoaded");
            applyWindowOnloadInitiator(_ownerDocument);
            customInitiators === null || customInitiators === void 0 ? void 0 : customInitiators(_ownerDocument, _defaultView);
            waitSynchronousScripts = new WaitSynchronousScripts(); // Activate node

            hasInlineAttribute = node.hasAttribute(HTML_ATTRIBUTE_INLINE);
            _context.next = 39;
            return transformToOriginalAttribute({
              node: node,
              allowClickOverrides: hasInlineAttribute ? false : isLastClicked,
              onlyModifyAttributes: hasInlineAttribute,
              setVisualParentIfClassOfParent: visual === null || visual === void 0 ? void 0 : visual.setVisualParentIfClassOfParent,
              overwriteAttributeValue: overwriteAttributeValue
            });

          case 39:
            _yield$transformToOri = _context.sent;
            performedClick = _yield$transformToOri.performedClick;

            if (!hasInlineAttribute) {
              _context.next = 46;
              break;
            }

            _context.next = 44;
            return putScriptInlineToDom(node);

          case 44:
            _context.next = 47;
            break;

          case 46:
            if (performedClick) {
              // Avoid auto replays between the same transaction
              setLastClickedConnectedCounter(undefined);
            }

          case 47:
            _context.next = 49;
            return Promise.all(waitSynchronousScripts.diff());

          case 49:
            node.dispatchEvent(new CustomEvent(OPT_IN_CONTENT_BLOCKER, {
              detail: {
                blocker: blocker,
                gotClicked: isLastClicked
              }
            }));
            document.dispatchEvent(new CustomEvent(OPT_IN_CONTENT_BLOCKER, {
              detail: {
                blocker: blocker,
                element: node,
                gotClicked: isLastClicked
              }
            }));
            unblockedNodes.push(row);
            _context.next = 55;
            break;

          case 54:
            if (visual && !isVisualCb) {
              createVisual(_objectSpread({
                node: row.node,
                blocker: row.blocker
              }, visual));
            }

          case 55:
            _context.next = 11;
            break;

          case 57:
            _context.next = 62;
            break;

          case 59:
            _context.prev = 59;
            _context.t0 = _context["catch"](9);

            _iterator.e(_context.t0);

          case 62:
            _context.prev = 62;

            _iterator.f();

            return _context.finish(62);

          case 65:
            // This transaction is "complete"
            if (unblockedNodes.length) {
              // Definitely reset now our last clicked counter to avoid double auto plays
              if (foundAnyLastClicked) {
                setLastClickedConnectedCounter(undefined);
              } // Do this before the events below to keep the initiators intact (e.g. jQuery.fn.ready)


              setCurrentlyInTransaction(false);
              document.dispatchEvent(new CustomEvent(OPT_IN_CONTENT_BLOCKER_ALL, {
                detail: {
                  unblockedNodes: unblockedNodes
                }
              }));
              unblockedNodes.forEach(function (_ref2) {
                var node = _ref2.node;
                node.setAttribute(HTML_ATTRIBUTE_UNBLOCKED_TRANSACTION_COMPLETE, "1");
                node.dispatchEvent(new CustomEvent(OPT_IN_CONTENT_BLOCKER_ALL, {
                  detail: {
                    unblockedNodes: unblockedNodes
                  }
                }));
              }); // The initiators (e.g. jQuery.ready) are all loaded in a new "thread" with a `setTimeout`,
              // but we need to make sure this event is dispatched afterwards.

              setTimeout(function () {
                transactionClosed === null || transactionClosed === void 0 ? void 0 : transactionClosed(unblockedNodes);
              }, 0);
            } else {
              setCurrentlyInTransaction(false);
            }

          case 66:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[9, 59, 62, 65]]);
  }));
  return _findAndUnblock.apply(this, arguments);
}

export { findAndUnblock };